export default function download( blob, filename ) {
    if ( navigator.msSaveBlob ) {
        navigator.msSaveBlob( blob, filename );
    } else {
        const url = URL.createObjectURL( blob );

        const element = document.createElement( 'a' );
        element.setAttribute( 'href', url );
        element.setAttribute( 'target', '_blank' );
        element.setAttribute( 'download', filename );
        element.style.display = 'none';
        document.body.appendChild( element );
        element.click();
        document.body.removeChild( element );

        window.URL.revokeObjectURL( url );
    }
}
